import FilterFactory from '@/lib/filterFactory';

export default class CancellationReasonsFilter {
    filterHandlers = {
        update: 'cancellationReasonsFilter/updateFilter',
        reset: 'cancellationReasonsFilter/resetFilter',
        resetState: 'cancellationReasonsFilter/resetFilterState',
        removeSelected: 'cancellationReasonsFilter/removeSelectedFilter',
    };
    filterModel = {};

    constructor() {
        const filter = new FilterFactory();

        filter.createSearchEntity('title');
        filter.setPlaceholder('title', 'По названию');
        filter.setName('title', 'search_title');
        filter.setPreviewName('title', 'Название');
        filter.setClassName('title', 'col-1-row-1');
        filter.setIconClassName('title', 'icon-store');
        filter.setAction('title', 'cancellationReasonsFilter/updateSearch');

        this.filterModel = filter.filterModel;
    }
}